import { IModel } from '../../@types/models/model';
import coreFields from '../helpers/coreFields';

const POI: IModel = {
  title: 'POI',
  apiPath: 'pristupacnost/poi',
  layerCallGroup: 'grp_poi_ju',
  forms: {
    default: {
      fields: ['naziv', 'vrsta_id', 'geom'],
    },
  },
  listViews: {
    default: {
      fields: ['id', 'naziv', 'vrsta_id', 'ocjena_avg', 'ocjena_cnt'],
      hidden: ['id'],
    },
  },
  fields: [
    coreFields.id,
    coreFields.created_on,
    {
      title: 'POI naziv',
      source: 'naziv',
      ttoken: 'pristupacnost:grading.poi_naziv',
      type: 'text',
      sort: true,
      filter: true,
    },
    {
      title: 'POI vrsta',
      source: 'vrsta_id',
      ttoken: 'pristupacnost:poi.vrsta',
      type: 'picker',
      subModel: {
        apiPath: 'pristupacnost/poi/vrste',
        format: '{label}',
        idattr: 'id',
      },
      translate: true,
      filter: true,
      readonly: true,
    },
    {
      title: 'AVG ocjena',
      source: 'ocjena_avg',
      ttoken: 'pristupacnost:poi.ocjena_avg',
      type: 'numeric',
      sort: true,
      filter: true,
    },
     {
      title: 'COUNT ocjena',
      source: 'ocjena_cnt',
      ttoken: 'pristupacnost:poi.ocjena_cnt',
      type: 'numeric',
      sort: true,
      filter: true,
    },
    coreFields.geom,
  ],
};

export default POI;
